export default "__VITE_ASSET__GiMlUB_m__"